import { Avatar, useTheme } from "@mui/material";
import { Perfil } from "../../../models/enum";
import chroma from "chroma-js";

type Props = {
  fotoDePerfil?: string;
  nome: string;
  perfil: Perfil;
  size: number;
};

export default function FelixAvatar({
  fotoDePerfil,
  nome,
  perfil,
  size,
}: Props) {
  const theme = useTheme();
  var hash = 0;
  for (var i = 0; i < nome.length; i++) {
    hash = nome.charCodeAt(i) + ((hash << 5) - hash);
  }
  var h = hash % 360;
  const color = chroma.hsl(
    h,
    theme.palette.mode === "light" ? 0.7 : 0.6,
    theme.palette.mode === "light"
      ? perfil === Perfil.INVESTIDOR
        ? 0.55
        : 0.45
      : perfil === Perfil.INVESTIDOR
      ? 0.4
      : 0.3
  );
  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        fontSize: size / 2,
        fontWeight: 900,
        color: theme.palette.text.primary,
        borderWidth: 2,
        borderColor:
          theme.palette.mode === "light"
            ? color.darken(2).hex()
            : color.brighten(2).hex(),
        borderStyle: "solid",
        backgroundColor: color.hex(),
      }}
      src={fotoDePerfil}
    >
      {nome[0]}
    </Avatar>
  );
}
